import { pipe, map, reverse, clone, addIndex, reduce, splitEvery } from 'ramda';
import {
    DAYS_FIRST_INDEX,
    HOURS_FIRST_INDEX,
    MINUTES_FIRST_INDEX,
    PERIODS_VALUE_MAP,
    SEGMENTS_VALUE_MAP
} from './constants';
import { divmod } from 'js/utils/math.util';

export const reduceIndexed = addIndex(reduce);
export const msToParts = partValues => (ms, maxIndex = partValues.length - 1) => {
    const result = [];

    partValues.reduceRight((prevRest, value, index) => {
        if (index > maxIndex) {
            result.unshift(0);
            return prevRest;
        }

        const [quotient, remainder] = divmod(prevRest, value);
        result.unshift(quotient);
        return remainder;
    }, ms);

    return result;
};

export const partsToMs = partValues => pipe(
    map(Number),
    reduceIndexed((accum, segment, i) => accum + partValues[i] * segment, 0)
);

export const msToPeriods = pipe(msToParts(PERIODS_VALUE_MAP), reverse);

export const msToSegments = msToParts(SEGMENTS_VALUE_MAP);

export const segmentsToMs = partsToMs(SEGMENTS_VALUE_MAP);

export const periodsToMs = pipe(clone, reverse, partsToMs(PERIODS_VALUE_MAP));

export const segmentsToPeriods = pipe(
    clone,
    reverse,
    splitEvery(2),
    map(period => Number(period.join('')))
);

export const getInitialIndex = ({ useDays, useHours }) => useDays
    ? DAYS_FIRST_INDEX
    : useHours
        ? HOURS_FIRST_INDEX
        : MINUTES_FIRST_INDEX;
